document.addEventListener("DOMContentLoaded", function() {
  // Only run on the page-no-header-footer template
  if (document.body.classList.contains("page-no-header-footer")) {

    // Remove sticky header wrapper if it exists
    var header = document.querySelector(".header-wrapper, .header__outer-wrapper, .header--sticky");
    if (header) {
      header.style.display = "none";          // hide it
      header.style.position = "static";       // remove sticky positioning
    }

    // Optional: remove scroll event listeners if sticky is JS-driven
    window.addEventListener("scroll", function(e) {
      if (header) {
        header.style.top = "auto";
        header.classList.remove("header--sticky");
      }
    });
  }
});
